import {Component, OnChanges, OnInit, Pipe, PipeTransform} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../shared/models/apiurl.models";
import {LoadingMaskServiceService} from "../../components/loading-frame/loading-frame.component";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {Product} from "../../models/product";
import {SystemApp} from "../../constans/SystemConfigurations";
import {TranslateService} from "@ngx-translate/core";
import {DatePipe} from "@angular/common";
import {AppService } from '../../../app/app.service';
import { MetaTagService } from '../../services/meta-tag.service';
declare function singlePage(): any;
export enum EntityType{
  NADLAN="Nadlan",
  CAR="Car",
  SALE2="Sale2"
}
type MediaItem =
    | { kind: 'image'; url: string }
    | { kind: 'video'; url: string };
export interface DetailsRow{
  field: string,
  fieldType: string,
  itemType: string | null,
  indexItemName: string | null,
  headerName?: string
}

@Pipe({
    name: 'localizedDescription',
    standalone: false
})
export class LocalizedDescriptionPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  // Known car-data fields — if any of these keys exist, it's a structured object
  private readonly CAR_FIELDS = ['producer', 'engineCapacity', 'year', 'fuel', 'hp', 'seats', 'fourWheelDrive', 'finishLevel', 'commercialNickname'];

  private tryParse(value: string): any {
    try { return JSON.parse(value); } catch {}
    try {
      const jsonLike = value
        .replace(/'/g, '"')
        .replace(/True/g, 'true')
        .replace(/False/g, 'false')
        .replace(/None/g, 'null');
      return JSON.parse(jsonLike);
    } catch {}
    return null;
  }

  transform(value: string | null | undefined): string {
    if (!value) return '';
    const parsed = this.tryParse(value);
    if (parsed && typeof parsed === 'object') {
      const lang = this.translateService.currentLang || this.translateService.defaultLang || 'he';
      const hasLangKeys = ['he', 'en', 'ar', 'ru', 'fr', 'de', 'tr'].some(l => parsed[l] !== undefined);
      if (hasLangKeys) {
        return parsed[lang] ?? parsed['he'] ?? parsed['en'] ?? value;
      }
      if (this.CAR_FIELDS.some(f => parsed[f] !== undefined)) {
        const params = Object.fromEntries(
          Object.entries(parsed).map(([k, v]) => [k, v ?? ''])
        );
        const translated = this.translateService.instant('sale4you.label.licenseCodeDes.header.2', params);
        return translated.replace(/\{\{[^}]+\}\}/g, '').replace(/ {2,}/g, ' ').trim();
      }
    }
    return value;
  }
}

@Pipe({
    name: 'getValueItemProduct',
    standalone: false
})
export class GetValueItemProduct implements PipeTransform{
  constructor(private  translateService: TranslateService, private datePipe: DatePipe) {

  }
  transform(value: any, ...args: any[]): any {
    const product = args[0]
    const headerName =value.headerName? this.translateService.instant(value.headerName): value.field
    if(value.fieldType == 'date'){
      const date = new Date(product[value.field]).toLocaleDateString();
      return headerName + ': '+ this.datePipe.transform(date,"dd/MM/yyyy hh:mm a")
    }
    if(value.fieldType == "list"){
      return headerName + ': ' + product[value.field][0][value.indexItemName]
    }
    if(value.fieldType == "boolean"){
      return headerName + ': ' +  (product[value.field] ? this.translateService.instant("sale4you.label.true"): this.translateService.instant("sale4you.label.false"))
    }
    if(value.fieldType == "object"){
      return headerName + ': ' + product[value.field][value.indexItemName]
    }
    return headerName + ': ' + product[value.field]
  }
}

@Component({
    selector: 'app-single',
    templateUrl: './single.component.html',
    styleUrls: ['./single.component.css'],
    standalone: false
})
export class SingleComponent implements OnInit,OnChanges {
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }


  productObj!: Product;
  base_url: string;
  tableDetailsList: DetailsRow[]=[];
  relatedProducts: any[] = [];


  constructor(private http: HttpClient, private apiKey: ApiUrl, private loadingMaskServiceService: LoadingMaskServiceService,public translate:TranslateService,public appService:AppService, private seo: MetaTagService) {
    this.base_url = SystemApp.base_url_api;
    const productId = this.apiKey.getNameSpacePos("/", 3);
    this.loadData(productId)
  }
  media: MediaItem[] = [];
  currentIndex = 0;

  private touchStartX = 0;

  private buildMedia() {
    const images = (this.productObj?.images ?? [])
        .filter((x: any) => !!x?.image)
        .map((x: any) => ({ kind: 'image', url: x.image } as MediaItem));

    const video = this.productObj?.video_url
        ? ([{ kind: 'video', url: this.productObj.video_url }] as MediaItem[])
        : [];
    this.media = [...images, ...video];
    this.currentIndex = Math.min(this.currentIndex, Math.max(this.media.length - 1, 0));
  }

  ngOnChanges(): void {}

  goTo(i: number) {
    if (i < 0 || i >= this.media.length) return;
    this.currentIndex = i;
  }

  next() {
    if (!this.media.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.media.length;
  }

  prev() {
    if (!this.media.length) return;
    this.currentIndex = (this.currentIndex - 1 + this.media.length) % this.media.length;
  }

// Swipe (mobile)
  onTouchStart(e: TouchEvent) {
    this.touchStartX = e.changedTouches[0]?.clientX ?? 0;
  }

  onTouchEnd(e: TouchEvent) {
    const endX = e.changedTouches[0]?.clientX ?? 0;
    const dx = endX - this.touchStartX;

    if (Math.abs(dx) < 40) return; // small move ignore
    if (dx < 0) this.next();
    else this.prev();
  }

// Optional: keyboard arrows
  onKeydown(e: KeyboardEvent) {
    if (e.key === 'ArrowRight') this.next();
    if (e.key === 'ArrowLeft') this.prev();
  }
  getDetailsByType(objectType:any):DetailsRow[]{
    switch ( objectType ) {
      case EntityType.CAR:
        return this.carFieldFunc();
        break;
      case EntityType.NADLAN:
        return this.nadlanFieldFunc();
        break;
      case EntityType.SALE2:
        return this.sale2FieldFunc();
        break;
    }
    return [];
  }
  carFieldFunc(): DetailsRow[] {
    return [
      {field: 'CodeProducer', fieldType: 'null', itemType: 'object', indexItemName: 'producer', headerName: "sale4you.label.CodeProducer"},
      {field: 'MainModel', fieldType: 'null', itemType: null, indexItemName: 'model' , headerName:"sale4you.label.MainModel"},
      {field: 'sconderyCategory', fieldType: 'object', itemType: null, indexItemName: 'name', headerName:"sale4you.label.sconderyCategory"},
      {field: 'mainCategory', fieldType: 'object', itemType: null, indexItemName: 'name', headerName:"sale4you.label.mainCategory"},
      {field: 'Color', fieldType: 'object', itemType: null, indexItemName: 'colorName', headerName:"sale4you.label.Color"},
      {field: 'area', fieldType: 'null', itemType: null, indexItemName: 'area', headerName:"sale4you.label.area"},
      {field: 'activeDescription', fieldType: 'null', itemType: null, indexItemName: 'active', headerName:"sale4you.label.active"},
      {field: 'year', fieldType: 'null', itemType: null, indexItemName: 'year', headerName:"sale4you.label.year"},
      {field: 'DrivingTest', fieldType: 'null', itemType: null, indexItemName: 'DrivingTest', headerName:"sale4you.label.DrivingTest"},
      {field: 'YearTest', fieldType: 'null', itemType: null, indexItemName: 'YearTest', headerName:"sale4you.label.YearTest"},
      {field: 'MonthTest', fieldType: 'null', itemType: null, indexItemName: 'MonthTest', headerName:"sale4you.label.MonthTest"},
      {field: 'mileage', fieldType: 'null', itemType: null, indexItemName: 'mileage', headerName:"sale4you.label.mileage"},
      {field: 'engineCapacity', fieldType: 'null', itemType: null, indexItemName: 'engineCapacity', headerName:"sale4you.label.engineCapacity"},
      {field: 'gearBox', fieldType: 'null', itemType: null, indexItemName: 'gearBox', headerName:"sale4you.label.gearBox"},
      {field: 'licenseNumber', fieldType: 'null', itemType: null, indexItemName: 'licenseNumber', headerName:"sale4you.label.licenseNumber"},
      {field: 'DisabledSuitable', fieldType: 'boolean', itemType: null, indexItemName: 'DisabledSuitable', headerName:"sale4you.label.DisabledSuitable"},
      {field: 'exchange', fieldType: 'null', itemType: null, indexItemName: 'exchange', headerName:"sale4you.label.exchange"},
      {field: 'monthOnRoad', fieldType: 'null', itemType: null, indexItemName: 'monthOnRoad', headerName:"sale4you.label.monthOnRoad"},
      {field: 'CurrentOwner', fieldType: 'object', itemType: null, indexItemName: 'Type', headerName:"sale4you.label.CurrentOwner"},
      {field: 'PastOwner', fieldType: 'object', itemType: null, indexItemName: 'Type', headerName:"sale4you.label.PastOwner"},
      {field: 'NumberOfOwner', fieldType: 'object', itemType: null, indexItemName: 'numberOnwer', headerName:"sale4you.label.numberOnwer"},
    ]
  }

  nadlanFieldFunc(): DetailsRow[] {
    return [
      {field: 'mainCategory', fieldType: 'object', itemType: null, indexItemName: 'name', headerName:"sale4you.label.mainCategory"},
      {field: 'sconderyCategory', fieldType: 'object', itemType: null, indexItemName: 'name', headerName:"sale4you.label.sconderyCategory"},
      {field: 'TypeOfNadlan', fieldType: 'object', itemType: null, indexItemName: 'nameHe', headerName:"sale4you.label.TypeOfNadlan"},
      {field: 'City', fieldType: 'object', itemType: null, indexItemName: 'nameHe', headerName:"sale4you.label.City"},
      {field: 'Street', fieldType: 'object', itemType: null, indexItemName: 'nameHe', headerName:"sale4you.label.Street"},
      {field: 'RoomsNum', fieldType: 'object', itemType: null, indexItemName: 'numberOfRooms', headerName:"sale4you.label.RoomsNum"},
      {field: 'ParkingNumber', fieldType: 'object', itemType: null, indexItemName: 'numberParking', headerName:"sale4you.label.ParkingNumber"},
      {field: 'Balcony', fieldType: 'null', itemType: null, indexItemName: 'Balcony', headerName:"sale4you.label.Balcony"},
      {field: 'updateTime', fieldType: 'null', itemType: null, indexItemName: 'updateTime', headerName:"sale4you.label.updateTime"},
      {field: 'HomeNum', fieldType: 'null', itemType: null, indexItemName: 'HomeNum', headerName:"sale4you.label.HomeNum"},
      {field: 'Floor', fieldType: 'null', itemType: null, indexItemName: 'Floor', headerName:"sale4you.label.Floor"},
      {field: 'TotalFloor', fieldType: 'null', itemType: null, indexItemName: 'TotalFloor', headerName:"sale4you.label.TotalFloor"},
      {field: 'Neighborhood', fieldType: 'null', itemType: null, indexItemName: 'Neighborhood', headerName:"sale4you.label.Neighborhood"},
      {field: 'Area', fieldType: 'null', itemType: null, indexItemName: 'Area', headerName:"sale4you.label.area"},
      {field: 'Entrance', fieldType: 'null', itemType: null, indexItemName: 'Entrance', headerName:"sale4you.label.Entrance"},
      {field: 'StatusOfNadlan', fieldType: 'null', itemType: null, indexItemName: 'StatusOfNadlan', headerName:"sale4you.label.availability"},
    ]
  }

  sale2FieldFunc(): DetailsRow[] {
    return [
      {field: 'typeProduct', fieldType: 'null', itemType: null, indexItemName: 'typeProduct', headerName:"sale4you.label.typeProduct"},
      {field: 'thirdCategory', fieldType: 'null', itemType: null, indexItemName: 'thirdCategory', headerName:"sale4you.label.thirdCategory"},
      {field: 'area', fieldType: 'null', itemType: null, indexItemName: 'area', headerName:"sale4you.label.area"},
      {field: 'mainCategory', fieldType: 'null', itemType: null, indexItemName: 'mainCategory', headerName:"sale4you.label.mainCategory"},
      {field: 'sconderyCategory', fieldType: 'null', itemType: null, indexItemName: 'sconderyCategory', headerName:"sale4you.label.sconderyCategory"},
      {field: 'HomeNum', fieldType: 'null', itemType: null, indexItemName: 'HomeNum', headerName:"HomeNum"},
      {field: 'Floor', fieldType: 'null', itemType: null, indexItemName: 'Floor', headerName:"Floor"},
    ]
  }

  loadRelatedProducts(currentId: string): void {
    const resourcetype = this.productObj?.resourcetype;
    console.log('[Related] resourcetype:', resourcetype, '| currentId:', currentId);
    if (!resourcetype) {
      console.warn('[Related] no resourcetype, skipping');
      return;
    }

    const price = Number(this.productObj?.price);
    const body: any = {};
    if (price && !isNaN(price) && price > 0) {
      body['min_price'] = Math.floor(price * 0.7);
      body['max_price'] = Math.ceil(price * 1.3);
    }

    const url = `${this.base_url}/clientAjax/productVFilteriewSet?model_class=${resourcetype}&offset=1&limit=12`;
    console.log('[Related] calling:', url, '| body:', body);
    this.http.post<any>(url, body, this.options).subscribe({
      next: (res) => {
        console.log('[Related] response:', res);
        this.relatedProducts = (res?.object_list ?? [])
          .filter((p: any) => String(p.id) !== String(currentId))
          .slice(0, 10);
        console.log('[Related] final list:', this.relatedProducts.length, 'items');
      },
      error: (err) => {
        console.error('[Related] error:', err);
        this.relatedProducts = [];
      }
    });
  }

  ngOnInit(): void {

  }
  loadData(productId: string): void{
    this.loadingMaskServiceService.setOnLoadingMask(true, true);
    this.getProduct(productId).subscribe((res)=>{
      this.productObj = res;

      // Dynamic SEO for this listing
      const firstImage = (res.images?.[0] as any)?.image || undefined;
      this.seo.updateForProduct({
        title:       res.title || res.name || 'מודעה',
        description: res.description
          ? (res.description as string).replace(/<[^>]+>/g, '').slice(0, 160)
          : 'צפה במודעה זו ב-Sale4ALL',
        image:       firstImage,
        price:       res.price ?? undefined,
        currency:    'ILS',
      });

      this.fixData(this.productObj)

      this.tableDetailsList = this.getDetailsByType(this.productObj.resourcetype);
      this.buildMedia();
      setTimeout(()=>singlePage(),200)
      this.loadingMaskServiceService.setOnLoadingMask(false, false);
      this.loadRelatedProducts(productId);
    },()=>{
      this.loadingMaskServiceService.setOnLoadingMask(false, false);
    })
  }


  private handleObserverError(error: any): Observable<any>{
    this.loadingMaskServiceService.setOnLoadingMask(false, false);
    return throwError(error.error || error)
  }

  getProduct(productId:string): Observable<any>{
    return this.http.get(this.apiKey.getProduct(productId), this.options)
      .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
      );
  }


  getProperty(item: DetailsRow) {
    if(item.field == "images")
      return;

    return "abed"
  }
  fixData(productObj:Product ){
    if( productObj.resourcetype==EntityType.CAR){
      if(this.productObj.activeDescription){
        this.productObj.activeDescription=this.translate.instant('sale4you.label.status.active')
      }
      this.productObj.activeDescription=this.translate.instant('sale4you.label.status.inactive')

      if(this.productObj.DrivingTest){
        this.productObj.DrivingTest=this.translate.instant('sale4you.label.HaveDrivingTest')
      }
      this.productObj.DrivingTest=this.translate.instant('sale4you.label.HaveNotDrivingTest')

      if(this.productObj.exchange){
        this.productObj.exchange=this.translate.instant('sale4you.label.exchange')
      }
      this.productObj.exchange=this.translate.instant('sale4you.label.Notexchange')


    }
    if(productObj.resourcetype==EntityType.NADLAN){
      if(this.productObj.Balcony){
        this.productObj.Balcony=this.translate.instant('sale4you.label.have')
      }
      this.productObj.Balcony=this.translate.instant('sale4you.label.haveNot')

      if(this.productObj.Entrance){
        this.productObj.Entrance=this.translate.instant('sale4you.label.have')
      }
      this.productObj.Entrance=this.translate.instant('sale4you.label.haveNot')
    }

    if(productObj.resourcetype==EntityType.SALE2){

    }

  }
  public addToWishList($event:any,product: Product){
    $event.preventDefault();
    this.appService.addToWishList(product);
  }

}
